import { render, staticRenderFns } from "./student-quote-info.vue?vue&type=template&id=8e2c84f8&scoped=true&"
import script from "./student-quote-info.vue?vue&type=script&lang=js&"
export * from "./student-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./student-quote-info.vue?vue&type=style&index=0&id=8e2c84f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2c84f8",
  null
  
)

export default component.exports